module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "content-view"
  }, [_c('div', {
    staticClass: "content",
    class: {
      'is-edit': _vm.components.length > 0
    }
  }, [_vm._l((_vm.components), function(item, index) {
    return _c('div', {
      staticClass: "component-item"
    }, [(item.name === 'film') ? _c('film', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'goods') ? _c('goods', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'heading') ? _c('heading', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'slider') ? _c('slider', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'writing') ? _c('writing', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [_c('div', {
    staticClass: "edit-btn content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "round": ""
    },
    on: {
      "click": _vm.plantingShow
    }
  }, [_vm._v("编辑内容")])], 1)])], 2)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "width": "80%",
      "title": "编辑文章",
      "fullscreen": "",
      "lock-scroll": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('section', {
    staticClass: "section section-white view-warp"
  }, [_c('draggable', {
    staticClass: "components-view",
    attrs: {
      "options": _vm.dragIssuesOptions
    },
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.initData),
      callback: function($$v) {
        _vm.initData = $$v
      },
      expression: "initData"
    }
  }, _vm._l((_vm.initData), function(item, index) {
    return _c('div', {
      staticClass: "component-control"
    }, [(item.name === 'film') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-video"
      }
    })]), _vm._v("\n            视频\n          ")] : _vm._e(), _vm._v(" "), (item.name === 'goods') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-goods"
      }
    })]), _vm._v("\n            商品\n          ")] : _vm._e(), _vm._v(" "), (item.name === 'heading') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-title"
      }
    })]), _vm._v("\n            标题\n          ")] : _vm._e(), _vm._v(" "), (item.name === 'slider') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-slider"
      }
    })]), _vm._v("\n            轮播\n          ")] : _vm._e(), _vm._v(" "), (item.name === 'writing') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-text"
      }
    })]), _vm._v("\n            文本\n          ")] : _vm._e()], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "template-view"
  }, [_c('div', {
    staticClass: "template"
  }, [_c('div', {
    staticClass: "template-header"
  }, [_c('div', {
    staticClass: "template-title",
    style: ('background: #fff url(' + _vm.headerBg + ') no-repeat bottom; background-size: 100% auto;')
  }, [_c('span', [_vm._v("标题")])])]), _vm._v(" "), _c('draggable', {
    staticClass: "components-wrap",
    attrs: {
      "options": _vm.dragViewOptions
    },
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.components),
      callback: function($$v) {
        _vm.components = $$v
      },
      expression: "components"
    }
  }, _vm._l((_vm.components), function(item, index) {
    return _c('div', {
      staticClass: "component-item",
      on: {
        "click": function($event) {
          return _vm.setCurrent(index)
        }
      }
    }, [_c('transition', {
      attrs: {
        "name": "el-fade-in-linear"
      }
    }, [(_vm.editorIndex === index) ? _c('div', {
      staticClass: "iconfont icon-trash-alt",
      on: {
        "click": _vm.removeCurrent
      }
    }) : _vm._e()]), _vm._v(" "), (item.name === 'film') ? _c('film', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'goods') ? _c('goods', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'heading') ? _c('heading', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'slider') ? _c('slider', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'writing') ? _c('writing', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e()], 1)
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "setting-view"
  }, [(_vm.editorIndex === null) ? _c('div', {
    staticClass: "view-placeholder"
  }, [_c('i', {
    staticClass: "iconfont icon-shapes"
  }), _vm._v("\n          请拖选左侧挂件\n        ")]) : _vm._e(), _vm._v(" "), _c('filmEditor', {
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "change": _vm.getVideo
    }
  }), _vm._v(" "), _c('goodsEditor', {
    attrs: {
      "res": _vm.editorData
    }
  }), _vm._v(" "), _c('headingEditor', {
    attrs: {
      "res": _vm.editorData
    }
  }), _vm._v(" "), _c('sliderEditor', {
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindImgs": _vm.showImgs,
      "bindLinks": _vm.showLinks
    }
  }), _vm._v(" "), _c('writingEditor', {
    attrs: {
      "res": _vm.editorData
    }
  })], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "btn-save",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveConfig
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgsVisible,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeimgsVisible
    }
  }), _vm._v(" "), _c('linkSetter', {
    attrs: {
      "visible": _vm.linksVisible
    },
    on: {
      "setLink": _vm.setLink,
      "closeDialog": _vm.closeDialog
    }
  }), _vm._v(" "), _c('goodsPicker', {
    attrs: {
      "visible": _vm.goodsVisible
    },
    on: {
      "pickGoods": _vm.pickGoods,
      "closeDialog": _vm.closeDialog
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-db33194a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db33194a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/function/richTextEditor.vue
// module id = 2942
// module chunks = 0